module.exports = __webpack_public_path__ + "img/replay.16028afa.svg";